/** Columna débito/crédito del extracto. `statementColumn` gana (Receiving invertido). */

export function isAccountStatementDebitRow(row, { includePendingPrepayment = false } = {}) {
  if (!row) return false;
  if (row.statementColumn === "debit") return true;
  if (row.statementColumn === "credit") return false;
  if (includePendingPrepayment && row.type === "pending_prepayment") return true;
  return (
    row.type === "payment" ||
    row.type === "shipping_pending" ||
    row.type === "debit_note"
  );
}

export function isAccountStatementCreditRow(row) {
  if (!row) return false;
  if (row.statementColumn === "credit") return true;
  if (row.statementColumn === "debit") return false;
  return (
    row.type === "collect" ||
    row.type === "invoice_shipper" ||
    row.type === "expense" ||
    row.type === "credit_note"
  );
}

export function accountStatementDebitDisplayAmount(row) {
  if (!row) return 0;
  return Math.abs(Number(row.amount) || 0);
}
